define(["data/config"], function(config) {
    var initApplicationForm = function($element) {
        $($element).on("change", ".select-open", function(e) {
            var name = $(this).data("name");
            if (
                $(this)
                    .find(":selected")
                    .val()
                    .indexOf("please-state") !== -1
            ) {
                $("#" + name + "-open")
                    .removeClass("u_hidden")
                    .find("input")
                    .focus();
            } else {
                $("#" + name + "-open")
                    .addClass("u_hidden")
                    .find("input")
                    .val("");
            }
        });

        $($element).on("change", ".select, .select-open", function(e) {
            if (
                $(this)
                    .find(":selected")
                    .val()
            ) {
                $(this)
                    .parent(".c_uiInputSelectWrapper")
                    .removeClass("c_uiInput--error");
            }
        });

        $($element).on("submit", function(e) {
            var elements = $(this).find("[data-settings]");
            var submitFail = false;
            elements.each(function(i, el) {
                var settings = $(el).data("settings");
                if (settings && settings.required) {
                    var $select = $(el).find('select');
                    var $input = $(el).find('input');

                    if (
                        (($select.length && $input.length && !$(el).find(":selected").val() && !$input.val()))
                        || ($select.length && !$input.length && !$(el).find(":selected").val())
                        || ($input.length && !$select.length && !$input.val())
                    ) {
                        $(el).find(".c_uiInputSelectWrapper").addClass("c_uiInput--error");
                        e.preventDefault();
                        submitFail = true;
                    }
                }
            });
            if (!submitFail) {
                document.getElementById("c_uiButton--main").className +=
                    " c_uiButton--loading";
            }
        });

        $(".c_uiForm-block--checkbox").each(function(i, el) {
            if ($(el).data("settings") !== undefined) {
                // Max number of checkboxes checked
                var limit = $(el).data("settings").limit;
                if (limit) {
                    var checkboxes = $(el).find('input[type="checkbox"]');
                    $(el).on("change", 'input[type="checkbox"]', function(e) {
                        var current = checkboxes.filter(":checked").length;
                        checkboxes
                            .filter(":not(:checked)")
                            .prop("disabled", current >= limit);
                    });
                }

                // No repeated checkboxes comparing to the previous checkbox input
                var no_repeat = $(el).data("settings").no_repeat;
                if (no_repeat) {
                    var selected;
                    var prev_checkboxes = $(el)
                        .prev()
                        .find('input[type="checkbox"]');
                    $(el)
                        .prev()
                        .on("change", 'input[type="checkbox"]', function(e) {
                            selected = prev_checkboxes
                                .filter(":checked")
                                .map(function() {
                                    return this.value;
                                })
                                .toArray();
                            var current_checkboxes = $(el).find(
                                'input[type="checkbox"]'
                            );
                            current_checkboxes
                                .filter(function() {
                                    return !$.inArray($(this).val(), selected);
                                })
                                .prop("disabled", true)
                                .prop("checked", false);
                            current_checkboxes
                                .filter(function() {
                                    return $.inArray($(this).val(), selected);
                                })
                                .prop("disabled", false);
                        });
                }

                // Minimum checkboxes required if checkbox is required
                var min = $(el).data("settings").minimum;
                if (min) {
                    var checkboxes = $(el).find('input[type="checkbox"]');
                    $(el).on("change", 'input[type="checkbox"]', function(e) {
                        var current = checkboxes.filter(":checked").length;
                        checkboxes
                            .filter(":not(:checked)")
                            .prop("required", current < min);
                    });
                }
            }
        });

        var $amount = $element.find('.payment-options');
        var $amountOther = $element.find(".amount-other");
        var $userAmount = $element.find(".user-amount");
        var $userInfo = $element.find("#user-info");

        $amount.on("click", function (e) {
            let $target = $(e.target);
            if ($target.is('input') && $target.val() !== 'on' && $target.val() > 0) {
                $userInfo.removeClass('u_hidden');
                $userInfo.find('input[name=payment_name]').attr('required', true);
                $userInfo.find('input[name=payment_email]').attr('required', true);
            } else {
                $userInfo.addClass('u_hidden');
                $userInfo.find('input[name=payment_name]').removeAttr('required', true);
                $userInfo.find('input[name=payment_email]').removeAttr('required', true);
            }
        });

        $amountOther.on("keyup", function (e) {
            $amountOther.val($amountOther.val().replace(/[^\d]/, ''));

            if (!isNaN($amountOther.val()) && $amountOther.val() > 0) {
                $userInfo.removeClass('u_hidden');
                $userInfo.find('input[name=payment_name]').attr('required', true);
                $userInfo.find('input[name=payment_email]').attr('required', true);
                $userAmount.val($amountOther.val());
            } else {
                $userInfo.addClass('u_hidden');
                $userInfo.find('input[name=payment_name]').removeAttr('required', true);
                $userInfo.find('input[name=payment_email]').removeAttr('required', true);
            }
        });
    };

    var apply = function($element) {
        initApplicationForm($element);
    };

    return {
        name: "applicationForm",
        apply: apply
    };
});
